import Hero from "../components/Hero";
import About from "../components/About";
import RecentBuilds from "../components/RecentBuilds";
import Services from "../components/Services";
import Contact from "../components/Contact";
import Hero2 from "../components/Hero2";
import About2 from "../components/About2";
export default function HomePage() {
  return (
    <>
      
        <Hero />
      
      <About2 />
      <RecentBuilds />
      <Services />
      <Contact />
    </>
  );
}
